<template>
  <div class="process-select-node">
    <el-dialog class="process-select-node-dialog" title="通知节点内控件人员" :visible.sync="dialogVisible" :before-close="cancel" center @open="open()" :close-on-click-modal="false" append-to-body>
      <div class="selected">
        <select-person :remoteSearch="true" :treeData="allData" :select="select" ref="select" :type="'selectNode'" :isRadio="'multiple'" :isParentSelect="'noselect'"></select-person>
      </div>
      <div class="buttons">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="cancel()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectPerson from '../../system/select-person'

export default {
  name: 'ProcessSelectCustom',
  props: ['dialogVisible', 'allData', 'candidates'],
  components: {
    SelectPerson
  },
  data () {
    return {
      select: []
    }
  },
  methods: {
    open () {
      this.select = this.candidates || []
    },
    save () {
      let select = []
      this.$refs.select.getSelectedList().forEach(m => {
        select.push({
          'targetId': m.id,
          'name': m.name,
          'columnId': m.columnId
        })
      })
      this.$emit('saveSelectNode', {
        'candidates': select
      })
    },
    cancel () {
      this.$emit('closeNodeDialog')
    }
  }

}
</script>

<style lang="scss">
 .process-select-node-dialog{
    .el-dialog {
      height: 420px;
      width: 646px;
      div.el-dialog__body {
        padding: 0 0 0 0;
        .selected {
          margin-top: 20px;
          .el-tree {
           > .el-tree-node >div:nth-child(1) .el-checkbox{
             display: none;
            }
          }
        }
        .buttons {
          text-align: center;
          margin-top: 25px;
          button {
            width: 104px;
            height: 30px;
            span {
              font-size: 16px;
            }
            &:first-child {
              margin-right: 35px;
            }
          }

        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/process/design/process-dialog-select-node.vue